"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const locale_1 = require("./locale");
const formatDate = (brand, inputDate, formatOptions, overrides) => {
    const locale = (0, locale_1.getLocale)(brand);
    const option = overrides?.[brand] ?? formatOptions;
    const date = new Date(inputDate);
    if (Number.isNaN(date.getTime())) {
        throw new Error(`unable to parse date input, ${inputDate}`);
    }
    return new Intl.DateTimeFormat(locale.toString(), option).format(date);
};
exports.formatDate = formatDate;
